import { StandardUserRoles } from '@quadminds/shared/commons';
import { StorkModules, StandardStorkRoles } from '../enums';

const StorkViewerRoles = [StandardStorkRoles.DEFAULT, StandardUserRoles.DEFAULT];
const StorkEditorRoles = [...StorkViewerRoles, StandardStorkRoles.EDITOR];
const StorkAdminRoles = [...StorkEditorRoles, StandardUserRoles.ADMIN, StandardStorkRoles.ADMIN];

const StorkAppModuleReduce = [
    StorkModules.KANBAN,
    StorkModules.TABLE_VIEW,
    StorkModules.MAP_VIEW,
    StorkModules.PROFILE,
    StorkModules.TAGS,
    StorkModules.VEHICLES,
    StorkModules.SEMITRAILERS,
    StorkModules.DRIVERS,
    StorkModules.CARRIERS,
    StorkModules.ACCOUNTS,
    StorkModules.LOCATIONS,
    StorkModules.ZONES,
    StorkModules.ALERTS_EVENTS,
];

const StorkEditorModules = [...StorkAppModuleReduce, StorkModules.OPERATIVE_STANDARDS];

export const StorkGroupedRoles = {
    viewer: {
        roles: StorkViewerRoles,
        appModules: StorkAppModuleReduce,
    },
    editor: {
        roles: StorkEditorRoles,
        appModules: StorkEditorModules,
    },
    admin: {
        roles: StorkAdminRoles,
        appModules: Object.values(StorkModules).filter((module) => module !== StorkModules.REPORTS),
    },
};
